import React from 'react'

export const MaleAvatar = ({ color, height, width }) => (
  <svg width={width} height={height} viewBox='0 0 15.603 20.514'>
    <path
      fill={color}
      d='M108.665,10.033c2.281,0,4.13-2.246,4.13-5.016S112.188,0,108.665,0s-4.13,2.246-4.13,5.016S106.384,10.033,108.665,10.033Z'
      transform='translate(-100.864 0)'
    />
    <path
      fill={color}
      d='M41.9,300.459c0-.169,0-.048,0,0Z'
      transform='translate(-41.895 -282.766)'
    />
    <path
      fill={color}
      d='M308.085,301.64c0-.046,0-.321,0,0Z'
      transform='translate(-292.483 -283.815)'
    />
    <path
      fill={color}
      d='M57.5,184.812c-.076-4.826-.707-6.2-5.53-7.072a3.388,3.388,0,0,1-4.523,0c-4.771.861-5.439,2.216-5.527,6.915-.007.384-.011.4-.012.359,0,.083,0,.238,0,.507,0,0,1.148,2.315,7.8,2.315s7.8-2.315,7.8-2.315c0-.173,0-.293,0-.375A3.1,3.1,0,0,1,57.5,184.812Z'
      transform='translate(-41.907 -167.322)'
    />
  </svg>
)

MaleAvatar.defaultProps = {
  color: '#fff',
  height: 21,
  width: 16
}
